export function browserExtensionApi(): string {
  return 'browser-extension-api';
}
